<template>
  <section class="vl-region  vl-region--small  vl-region--alt">
    <div class="vl-layout vl-layout vl-layout--full">
      <div class="vl-grid vl-grid--is-stacked">

          <!-- Left column -->
          <div class="vl-col--12-12--xs vl-col--7-12--s vl-col--9-12">
            <div v-if="shouldShowCtiDetails" class="vl-description-data">
              <dl class="vl-grid vl-grid--is-stacked">
                <div class="vl-col--1-9 vl-col--1-2--s vl-col--1-2--xs">
                  <dt class="vl-description-data__label">Behandelthema</dt>
                  <dd class="vl-description-data__value">{{ startThemeName }}</dd>
                </div>
                <div class="vl-col--1-9 vl-col--1-2--s vl-col--1-2--xs">
                  <dt class="vl-description-data__label">Lijn</dt>
                  <dd class="vl-description-data__value">{{ parentInteractionWorkgroupName }}</dd>
                </div>
                
                <div class="vl-col--1-9 vl-col--1-2--s vl-col--1-2--xs">
                  <dt class="vl-description-data__label">CTI interactie ID</dt>
                  <dd class="vl-description-data__value">
                    {{ (parentInteractionId || '').split(';')[0] }}
                    <span title="Kopiëren" @click="copyInteractionId" class="">
                      <span class="vl-icon vl-icon--light vl-vi vl-vi-copy-paste" aria-hidden="true"></span>
                    </span>
                  </dd>
                </div>
                <div class="vl-col--1-9 vl-col--1-2--s vl-col--1-2--xs">
                  <dt class="vl-description-data__label">CTI Kanaal</dt>
                  <dd class="vl-description-data__value">{{ channelName }}</dd>
                </div>
                <div class="vl-col--1-9 vl-col--1-2--s vl-col--1-2--xs">
                  <dt class="vl-description-data__label">Status</dt>
                  <dd class="vl-description-data__value">
                    <div :class="['vl-pill', readableInteractionState === 'Verbonden' ? 'vl-pill--success' : 'vl-pill--error']">
                      <span class="vl-pill__text">{{ readableInteractionState }}</span>
                    </div>
                  </dd>
                </div>
                <div v-if="user.reservedCustomStatus" class="vl-col--1-9 vl-col--1-3--s vl-col--1-3--xs">
                  <dt class="vl-description-data__label">Gereserveerde status</dt>
                  <dd class="vl-description-data__value">
                    <div class="vl-pill">
                      <span class="vl-pill__text">
                        <span class="timer-dot"></span>
                        {{ user.reservedCustomStatus }}
                      </span>
                    </div>
                  </dd>
                </div>
              </dl>
            </div>
          </div>

          <!-- Right column -->
          <div class="vl-col--12-12--xs vl-col--5-12--s vl-col--3-12 vlw__cti-toolbar__actions">
            <div class="vl-action-group vl-action-group--align-right">
              <!-- 
              <VlButton title="Opnemen" v-if="channelIsChat" :mod-disabled="!isAlerting"
                @click.prevent="acceptInteraction" class="divide" mod-narrow>
                <CustomIcon icon="play" />
              </VlButton>
              -->
              <VlButton v-if="!!contactId" @click="$store.commit('ui/internalTransfer/SHOW')" title="Interne transfer"
                :mod-disabled="shouldDisableTransfer" mod-narrow>
                <CustomIcon icon="internal-forwarding" />
              </VlButton>

              <VlButton v-if="!!contactId && showEndRegistrationButton" @click.prevent="showEndRegistrationModal = true"
                :mod-disabled="!canStartEndRegistration" title="Eindregistratie" mod-narrow>
                <span class="vl-icon vl-icon--large vl-vi vl-vi-list" aria-hidden="true"></span>
                <VlIcon v-if="hasSavedEndRegistration" icon="check" class="ml-4" mod-small />
              </VlButton>

              <VlButton v-if="!!contactId" @click.prevent="showFeedbackModal = true"
                :mod-disabled="!canStartEndRegistration" mod-narrow>
                Feedback
              </VlButton>

              <VlButton v-if="!!contactId" :title="cannotBeClosedBecause || 'Afsluiten'" @click.prevent="closeContact"
                :mod-disabled="!!cannotBeClosedBecause && !!isCtiLoading" mod-narrow>
                <CustomIcon icon="close" />
              </VlButton>
            </div>

          </div>
        </div>
      </div>

    <!-- Modals -->
    <portal to="modal" v-if="showEndRegistrationModal">
      <EndRegistration @close="showEndRegistrationModal = false" />
    </portal>
    <portal to="modal" v-if="showInternalTransferModal">
      <InternalTransfer @close="$store.commit('ui/internalTransfer/HIDE')" />
    </portal>
    <portal to="modal" v-if="showFeedbackModal">
      <Feedback @close="showFeedbackModal = false" />
    </portal>
  </section>
</template>

<script>
// Import shared components
import { mapState, mapGetters, mapActions } from 'vuex';
import Feedback from '@/components/modals/Feedback';
import EndRegistration from '@/components/modals/EndRegistration';
import InternalTransfer from '@/components/modals/InternalTransfer';

export default {
  name: 'CTIToolBar',

  components: {
    EndRegistration,
    Feedback,
    InternalTransfer,
  },

  data() {
    return {
      showFeedbackModal: false,
      showEndRegistrationModal: false,
    };
  },

  computed: {
    ...mapGetters('authentication', ['isLoggedIn', 'userName']),

    ...mapState('metadata', ['contactStatuses']),
    ...mapGetters('metadata', ['getWorkgroupSimplifiedNameById']),
    ...mapGetters('cti', [
      'parentInteractionId',
      'parentInteractionState',
      'parentInteractionWorkgroup',
      'isUserInAcw',
      'isAlerting',
      'isConnected',
      'isOnHold',
      'isPauseEnabled',
      'readableInteractionState',
    ]),
    ...mapState('cti', ['statusMessages', 'user']),
    ...mapState('cti', { isCtiLoading: 'isLoading' }),
    ...mapState('contact', ['hasSavedEndRegistration']),
    ...mapGetters('contact', [
      'channelName',
      'channelIsChat',
      'contactId',
      'isLoading',
      'lineId',
      'startThemeName',
      'canStartEndRegistration',
      'cannotBeClosedBecause',
      'workgroupId',
      'requiredEndRegistrationFields',
    ]),
    ...mapState('ui/internalTransfer', {
      showInternalTransferModal: 'showModal',
    }),

    showEndRegistrationButton() {
      return this.requiredEndRegistrationFields.length > 0;
    },

    shouldShowCtiDetails() {
      return this.contactId != null && this.parentInteractionId != null && this.isCtiLoading != null;
    },

    shouldDisableTransfer() {
      return (
        !this.contactId ||
        !this.workgroupId ||
        this.isLoading ||
        this.isUserInAcw ||
        (this.isCtiLoading && !this.isConnected)
      );
    },

    parentInteractionWorkgroupName() {
      if (this.workgroupId === undefined) return '';
      return this.getWorkgroupSimplifiedNameById(this.workgroupId);
    },
  },

  methods: {
    ...mapActions('contact', ['closeContact']),

    copyInteractionId() {
      const interactionId = (this.parentInteractionId || '').split(';')[0];
      if (interactionId) {
        navigator.clipboard.writeText(interactionId)
      }
    }
  },
};
</script>

<style lang="scss">
.vl-vi-copy-paste {
  cursor: pointer;
}

.vlw__cti-toolbar__actions {
  .vl-action-group {
    padding: 0.2rem;
    flex-wrap: wrap;
    justify-content: flex-end;
    overflow: hidden;

    .vl-button {
      font-size: 1.4rem;
      margin-right: 0.8rem;
      margin-bottom: 0.8rem;
    }

    .vl-button:last-child {
      margin-right: 0.0rem;
    }
  }
}

@media (max-width: 100px) {
  .vlw__cti-toolbar__actions .vl-action-group {
    flex-wrap: wrap; /* allow natural wrapping */
    justify-content: right; /* align with content */
    flex-direction: column;
 
    .vl-button {
      margin-right: 0;
      margin-bottom: 0.5rem;
    }
    .vl-button:last-child {
      margin-bottom: 0;
    }
  }
}

.vl-pill__text {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 1.4rem;
  font-weight: 500;
}

.vl-description-data .vl-description-data__value,
.vl-description-data .vl-description-data__data {
  display: block;
  font-size: 1.4rem;
  font-weight: 500;
}

/* Scheduled status */
.timer-dot {
  display: inline-block;
  height: 15px;
  width: 15px;
  background-color: #fbbf24;
  border-radius: 9999px;
  animation: pulse 1.5s infinite ease-in-out;
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.3;
  }
}
</style>
